export const errorHandler = (code: number) => {
  switch (code) {
    case 401:
      return 'Неверный логин или пароль';
    case 402:
      return 'Не заполнены обязательные поля';
    case 403:
      return 'Токен не совпал';
    case 405:
      return 'Пользователь с таким логином уже существует';
    // default:
    //   return '';
  }
};
